import { render, staticRenderFns } from "./TSimple.vue?vue&type=template&id=44ec830a&scoped=true&"
import script from "./TSimple.vue?vue&type=script&lang=js&"
export * from "./TSimple.vue?vue&type=script&lang=js&"
import style0 from "./TSimple.vue?vue&type=style&index=0&id=44ec830a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec830a",
  null
  
)

export default component.exports